<ng-template cellTemplate let-dataItem="dataItem" let-columnIndex="columnIndex">
    <span (click)="$event['ignoreClickOutside'] = true">
        <ng-container *ngIf="multiObjectValueType">
            {{getCellSummary(dataItem)}}
        </ng-container>
        <wbo-membership-type-multi-select-edit-control *ngIf="!multiObjectValueType"
                                                       [value]="EntityData.getField(dataItem, this.field)"
                                                       [readonly]="true" [hideOptionOpenOption]="true"
                                                       [viewFilter]="viewFilter"
                                                       (click)="setupCellActivation(columnIndex, $event)">
        </wbo-membership-type-multi-select-edit-control>
    </span>
</ng-template>
<ng-template editTemplate let-dataItem="dataItem" let-columnIndex="columnIndex" let-column="column"
             let-formGroup="formGroup">
    <wbo-edit-grid-cell-activator [columnIndex]="columnIndex"
                                  [editControl]="editControl"></wbo-edit-grid-cell-activator>
    <wbo-membership-type-multi-select-edit-control #editControl (focussed)="columnFocusHandler($event, columnIndex)"
                                                   [includeGuestOption]="includeGuestOption"
                                                   [multiObjectValueType]="multiObjectValueType"
                                                   [formControl]="formGroup.get(field)"
                                                   [attr.id]="elementId"
                                                   [viewFilter]="viewFilter"
                                                   (valueChange)="controlValueChange($event, dataItem, formGroup)"
                                                   [placeholder]="getPlaceholder(dataItem)">
    </wbo-membership-type-multi-select-edit-control>
</ng-template>
